import { Injectable } from "@angular/core";
import { GateFault, GateFaultDTO } from "../../../models/api/fault/gateFault";
import { RealtimeGateFault } from "../../../models/ws/realtimeGateFault";

@Injectable({
  providedIn: "root",
})
export class GateFaultUtilsService {
  /**
   * Updates the gate fault state with a new gate fault from the message.
   * Checks if the gate fault is already present in the state and updates it if so.
   * If not, adds it to the state.
   * Also refreshes the hierarchy
   * @param incomingGateFault The incoming gate fault
   * @param gateFaultStateUpdateFn A function to update the gate fault state
   * @param avoidRemove
   */
  public handleRealtimeGateFault(
    incomingGateFault: RealtimeGateFault,
    gateFaultStateUpdateFn: (updateFn: (existingGateFaults: GateFault[] | null) => GateFault[] | null) => void,
    avoidRemove?: boolean
  ) {
    if (incomingGateFault) {
      incomingGateFault = this.convertGateFault(incomingGateFault);

      gateFaultStateUpdateFn((existingGateFaults: GateFault[] | null) => {
        // doing this to return a new refernence so that listeners of the .asReadOnly signal will get the new value
        const faults = existingGateFaults ? [...existingGateFaults] : [];

        const existingIndex = faults?.map((fault) => fault.id).indexOf(incomingGateFault?.id);
        if (existingIndex !== undefined && existingIndex > -1) {
          if (!incomingGateFault.active && !avoidRemove) {
            faults.splice(existingIndex, 1);
          } else {
            faults[existingIndex] = incomingGateFault;
          }
        } else if (incomingGateFault.active) {
          faults?.unshift(incomingGateFault);
        } else {
          console.debug("Ignored incoming gateFault message: ", incomingGateFault);
        }

        return faults;
      });
    }
  }

  /**
   * Converts a GateFaultDTO (from the API) to a GateFault (our internal model).
   * This is a simple 1:1 mapping, no additional logic is performed.
   * @param gateFault The GateFaultDTO to convert.
   * @returns The converted GateFault.
   */
  public convertGateFault(gateFault: GateFaultDTO | RealtimeGateFault): GateFault {
    return {
      id: gateFault.id,
      faultType: gateFault.faultType,
      faultText: gateFault.faultText,
      repairStatus: gateFault.repairStatus,
      fixLink: gateFault.fixLink,
      active: gateFault.active,
      gateSystem: gateFault.gateSystem,
      triggeredAt: gateFault.triggered_at,
    };
  }
}
